if (!customElements.get('kofea-lid-deck')) {
  customElements.define('kofea-lid-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const stack = this.querySelector('[data-lid-stack]');
      const cards = [...this.querySelectorAll('[data-lid-card]')];
      const dots = [...this.querySelectorAll('[data-lid-dot]')];
      const name = this.querySelector('[data-lid-name]');
      const link = this.querySelector('[data-lid-link]');
      const count = this.querySelector('[data-lid-count]');
      const n = cards.length;
      if (n < 2) return;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const events = new AbortController();
      const on = (el, type, fn) => el.addEventListener(type, fn, { signal: events.signal });
      const pad = i => String(i).padStart(2, '0');
      let active = 0, busy = false, drag = null, timer = null, autoLeft = n, inView = false;

      const render = () => {
        cards.forEach((card, i) => {
          const o = (i - active + n) % n;
          card.dataset.o = o;
          card.setAttribute('aria-hidden', o ? 'true' : 'false');
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === active)));
        name.textContent = cards[active].dataset.name;
        link.href = cards[active].dataset.url;
        count.textContent = `${pad(active + 1)} / ${pad(n)}`;
      };
      const go = i => { active = (i + n) % n; render(); };
      // Front card flies off to the side, then tucks back behind the deck.
      const fling = dir => {
        if (busy) return;
        busy = true;
        const card = cards[active];
        card.classList.remove('is-dragging');
        card.classList.add('is-flung');
        card.style.transform = `translate3d(${dir * 125}%, 4%, 0) rotate(${dir * 20}deg)`;
        setTimeout(() => {
          card.classList.remove('is-flung');
          card.style.transform = '';
          go(active + 1);
          busy = false;
        }, motion.matches ? 0 : 360);
      };
      // ponytail: autoplay runs one lap only (accessibility: no endless motion), any interaction stops it.
      const stop = () => { autoLeft = 0; clearInterval(timer); name.setAttribute('aria-live', 'polite'); };
      const schedule = () => {
        clearInterval(timer);
        if (autoLeft > 0 && inView && !document.hidden && !motion.matches) {
          timer = setInterval(() => { if (--autoLeft <= 0) clearInterval(timer); fling(-1); }, 3000);
        }
      };

      on(stack, 'pointerdown', e => {
        const card = e.target.closest('[data-lid-card]');
        if (!card || card !== cards[active] || busy || e.button > 0) return;
        stop();
        drag = { x: e.clientX, dx: 0, card };
        card.setPointerCapture(e.pointerId);
        card.classList.add('is-dragging');
      });
      on(stack, 'pointermove', e => {
        if (!drag) return;
        drag.dx = e.clientX - drag.x;
        drag.card.style.transform = `translate3d(${drag.dx}px, 0, 0) rotate(${drag.dx / 16}deg)`;
      });
      const release = () => {
        if (!drag) return;
        const { dx, card } = drag;
        drag = null;
        if (Math.abs(dx) < 6 || Math.abs(dx) > stack.offsetWidth * 0.2) return fling(dx > 0 ? 1 : -1);
        card.classList.remove('is-dragging');
        card.style.transform = '';
      };
      on(stack, 'pointerup', release);
      on(stack, 'pointercancel', release);
      on(stack, 'keydown', e => {
        if (e.key === 'ArrowRight') { stop(); fling(-1); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { stop(); go(active - 1); e.preventDefault(); }
      });
      on(this.querySelector('[data-lid-next]'), 'click', () => { stop(); fling(-1); });
      on(this.querySelector('[data-lid-prev]'), 'click', () => { stop(); go(active - 1); });
      dots.forEach((dot, i) => on(dot, 'click', () => { stop(); go(i); }));
      on(document, 'visibilitychange', schedule);

      const observer = new IntersectionObserver(entries => {
        inView = entries[0].isIntersecting;
        schedule();
      }, { threshold: 0.5 });
      observer.observe(stack);
      render();
      this.cleanup = () => { events.abort(); observer.disconnect(); clearInterval(timer); };
    }
    disconnectedCallback() {
      this.cleanup?.();
      this.cleanup = null;
    }
  });
}
